/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';

import EmptyState from '@atlaskit/empty-state';
import type { EmptyStateProps } from '@atlaskit/empty-state/types';
import Text from '@atlaskit/primitives/text';

import { GenericErrorIcon } from './assets/GenericErrorIcon';

const styles = cssMap({
	textWrapper: {
		maxWidth: '235px',
		marginInline: 'auto',
		display: 'inline-block',
	},
});

export interface NavEmptyStateProps extends EmptyStateProps {}

export function NavEmptyState({
	testId = 'navigation-empty-state',
	renderImage = () => <GenericErrorIcon />,
	description,
	...restProps
}: NavEmptyStateProps) {
	return (
		<EmptyState
			{...restProps}
			testId={testId}
			renderImage={renderImage}
			headingLevel={3}
			headingSize="xsmall"
			description={
				<span css={styles.textWrapper}>
					<Text size="small" color="color.text.subtle">
						{description}
					</Text>
				</span>
			}
		/>
	);
}
